import { useEffect, useRef } from "react";
import PeopleCell from "./PeopleCell";
import { getDocPersons } from "../../../api/papers";

export default function PeopleCellLoader({ dns, value, onChange, single }) {
  const loadedRef = useRef(false);
  useEffect(() => {
    if (!dns) return;

    // 이미 값이 세팅되어 있다면 API 다시 호출 금지
    if (value.length > 0) return;

    let cancelled = false;

    (async () => {
      try {
        const list = await getDocPersons(dns);
        const mapped = list.map((p) => ({
          id: p.user.id,
          name:
            p.user.name ||
            `${p.user.last_name ?? ""}${p.user.first_name ?? ""}`,
        }));

        if (!cancelled) {
          // 동일한 배열이면 onChange 무시
          if (JSON.stringify(value) !== JSON.stringify(mapped)) {
            onChange(mapped);
          }
        }
      } catch (error) {
        console.error("문서 담당자 로드 오류:", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dns]);

  return <PeopleCell value={value} onChange={onChange} single={single} />;
}
